import { Key, useState } from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "../Icons/FacebookIcon";
import LinkedInIcon from "../Icons/LinkedInIcon";
import XIcon from "../Icons/XIcon";
import Button from "../Shared/Button";
import { Course } from "../../types/types";
import { Instructor } from "../../types/types";
import ReactMarkdown from 'react-markdown';
const Courses = ({ instructor }: { instructor?: Instructor }) => {
  const [showFullDescription] = useState(false);

  return (
    <div className="sm:pt-20 sm:mt-2 pt-7 text-burntBlack sm:pb-28 pb-10 mb-2">
      <h1 className="sm:text-[38px] text-lg font-bold sm:mb-8 mb-3">Courses</h1>
      <div className="flex lg:flex-row flex-col xl:gap-14 gap-8 justify-between">
        <div className="space-y-8 w-full">
          {Array.isArray(instructor?.courses) &&
            instructor?.courses.map((course: Course, index: Key) => {
              const descriptionWords = course.description.split(" ");
              const truncatedDescription = showFullDescription
                ? descriptionWords.join(" ")
                : descriptionWords.slice(0, 22).join(" ");
              return (
                <>
                  <div
                    key={index}
                    className="flex sm:gap-5 gap-2.5 sm:pb-12 pb-3 border-b border-black/20 w-full"
                  >
                    <Link className="sm:size-[160px] size-[70px]" to={`/course/${course.slug}`}>
                      <img
                        src={course.img_url}
                        alt="course"
                        className=" sm:min-w-[160px] min-w-[70px] h-full object-fit rounded-2xl border border-black/15"
                      />
                    </Link>
                    <div className="sm:space-y-3 space-y-1">
                      <Link className="w-full" to={`/course/${course.slug}`}>
                        <h1 className="font-bold md:text-2xl text-xl">{course.name}</h1>
                      </Link>
                      <p className="text-lightGray font-medium text-lg ">
                        <span className="font-medium text-sm text-lightGray/70">
                          <ReactMarkdown>{truncatedDescription}</ReactMarkdown>
                        </span>
                        {!showFullDescription && (
                          <Link
                            className="text-sm font-bold text-primary"
                            to={`/course/${course.slug}`}
                          >
                            {" "}
                            &nbsp; Learn more about {course.name}
                          </Link>
                        )}
                      </p>
                      <Link to={`/course/${course.slug}`}>
                        {" "}
                        <Button
                          variant="primary"
                          className="sm:!h-12 !h-8 sm:!text-base !text-[10px] sm:w-[160px] w-[90px] rounded-lg sm:mt-3 mt-1"
                        >
                          View Course
                        </Button>
                      </Link>
                    </div>
                  </div>
                </>
              );
            })}
        </div>

        <div className="sm:min-w-[406px]">
          <div className="sm:py-8 sm:px-4 p-5 border border-black/15 shadow rounded-2xl mb-4">
            <div className="flex items-center sm:gap-3 gap-2.5 sm:mb-5 mb-4">
              <div className="sm:size-14 size-12 rounded-full overflow-hidden border border-black/20">
                <img
                  className="object-cover object-[25%_75%] "
                  src={instructor?.photo}
                  alt="Instructor"
                />
              </div>
              <div className="text-burntBlack font-bold">
                <h1 className="mb-0.5 text-sm -tracking-[0.02em]">
                  Dr. {instructor?.firstName} {instructor?.lastName}
                </h1>
                <p className="text-lightGray font-medium text-xs tracking-[0.02em]">
                  Instructor
                </p>
              </div>
            </div>
            <div className="sm:mb-7 mb-6">
              <h1 className="font-bold sm:text-0.5xl tracking-[0.02em]">
                Publisher
              </h1>
              <p className="font-medium text-lightGray sm:text-base text-sm mt-1 sm:mt-3">
                <ReactMarkdown>{instructor?.description}</ReactMarkdown>
              </p>
            </div>
            <Link to="/consultation">
              <Button
                variant="transparent"
                className="before:!bg-primary hover:text-white sm:!h-[50px] !h-11 w-[140px] sm:w-[168px] !border-primary !border-2 text-primary sm:!text-xl !text-base"
              >
                Schedule now
              </Button>
            </Link>
          </div>
          <div className="sm:p-8 p-5 border border-black/15 shadow rounded-2xl sm:space-y-7 space-y-4">
            <div>
              <h1 className="sm:mb-5 mb-1 text-lightGray font-semibold sm:text-2xl">
                Email
              </h1>
              <p className="text-burntBlack sm:text-xl font-semibold break-all">
                {instructor?.email}
              </p>
            </div>
            <div>
              <h1 className="sm:mb-5 mb-1 text-lightGray font-semibold sm:text-2xl">
                Phone Numbers
              </h1>
              <div className="gap-5 items-center flex">
                <p className="text-burntBlack sm:text-xl font-semibold">
                  {instructor?.phone}
                </p>
                {/* <div className="size-2.5 bg-burntBlack rounded-full"></div> */}
                {/* <p className="text-burntBlack text-xl font-semibold">
                  01066402701
                </p> */}
              </div>
            </div>
            <div>
              <h1 className="sm:mb-5 mb-1 text-lightGray font-semibold sm:text-2xl">
                Contact
              </h1>
              <div className="flex sm:gap-8 gap-4 items-center">
                <Link to="/">
                  <XIcon className=" duration-300 transition-all ease-in-out text-primary hover:text-secondary size-4 sm:size-6" />
                </Link>
                <Link to={`${instructor?.linkedin}`}>
                  <LinkedInIcon className=" duration-300 transition-all ease-in-out text-primary hover:text-secondary size-4 sm:size-6" />
                </Link>
                <Link to={`${instructor?.facebook}`}>
                  <FacebookIcon className=" duration-300 transition-all ease-in-out text-primary hover:text-secondary size-4 sm:size-6" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Courses;
